<template >
<div class="container" >
  <h4 data-aos="fade-in">Privacy Policy</h4>
<p>
The content, forms, fields, references on www.kcco.co.in are purely meant for the purpose of effective communication, reference and information. Any details collected by us are important from the perspective of business and we take the best care of your interests by keeping it private and safe. While we collect any information or store it for future use, we take best care of the confidentiality and privacy of the details provided. 
</p>
<h5>
Information we collect
</h5>
<ul>
    <li> 
        Information provided by you in order to establish a communication or make a purchase
    </li>
    <li>
        Information about your use of our site including your site visit details that aim at depicting the site analytics
    </li>
    <li>
        Information that is a part of communication between you and the website
    </li>

</ul>

<h5>
Your Information Security
</h5>

<p>
We do not attempt to disclose any information provided by you in any manner. The only reason we collect your personal details is to help us establish prompt communication with you. In this process, we take all the possible measures to use the information in most authentic manner, so that their remains no loops and risks of any sort of information leakage. 
We don't sell, rent or share it with any third party and do not misuse any of the information provided by you in any way. 
However, the data may be used for future correspondence. We will only use it for editorial, feedback and internal record keeping purposes. 
We maintain highest level of control over how the information is handled, used and stored. Our privacy policy reassures a dependable and trustworthy association in every way possible! 
</p>

<h5>
Exceptions
</h5>

<p>
We are strict in the way we protect your information from any sort of threat or intervention. However, there are few exceptions to the disclosure of the information which is subject to these events. Your information would not be disclosed until unless any of these events take place:
<ul>
    <li>
        We sell any or all of our business to the buyer
    </li>
    <li>
        It is a legal demand to disclose your personal information
    </li>
    <li>
        To support an act of fraud protection and reduce the risk of fraud
    </li>

</ul>
</p>

<h5>
Electronic Security
</h5>
<p>
Unfortunately, anything or any data present on internet is prone to seepage. With your data travelling through various electronic modes and reaching us, and even when it is stored with us, we cannot completely and hence don't give any guarantee to protect it at every instance, owing to the unidentifiable aspects of different transfer and storage processes that works on internet. However, we can assure you of the protection of your data as far as it is in our scope and reach. We choose the best of methods and take every possible measure to protect any data from such threats and risks, nevertheless disclaiming the guarantee to the electronic security. 
</p>

<h5>
Changes to this policy
</h5>
<p>
Kartik Chugh & Co. can change this policy any time without sending a prior notice to any of the parties involved. This policy is subject to changes due to periodical reviews and timely modifications. The date of change is always updated on the bottom of the page. We recommend you to regularly visit this page to be updated with the latest privacy policy. 
</p>
<p>
By using this Site, you admit your acceptance of this policy.<br> 
Last Updated: 6th September 2019 
</p>

</div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");

*{
    font-family: 'Montserrat', sans-serif;
    text-align:justify;
}


</style>